import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"padding":"0 15px","width":"400px","height":"420px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw600 fs24 centered",
    style: {"color":"#696969"}
  }, "メッセージを送信")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = {
  class: "",
  style: {}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, "メールアドレスとお名前を入力することで、後で担当者からの通知が届きます。", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_15 = {
  key: 0,
  class: "ml15",
  style: {"margin-top":"-75px"}
}
const _hoisted_16 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "送信", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg disabled",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_20 = {
  key: 0,
  class: "fs14 fw400"
}
const _hoisted_21 = {
  key: 1,
  class: "fs14 fw400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_PPTosContent = _resolveComponent("PPTosContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "EmailNameFieldsModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll ",
    onBeforeOpen: _ctx.openModal,
    onBeforeClose: _ctx.fadeOutModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", {
          class: "ofs centered",
          style: _normalizeStyle(`height: ${_ctx.contentHeight}px;overscroll-behavior: contain;`)
        }, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", {
              class: _normalizeClass(`${_ctx.companyField ? `` : `mt20`}`)
            }, [
              _createVNode(_component_MdTextfieldTag, {
                fieldStyle: "min-width:280px;max-width:100%;",
                style: {"height":"56px","min-width":"280px","max-width":"100%"},
                class: "fl fs16 text-left",
                type: `Name`,
                name: `お名前(必須)`,
                value: _ctx.userInfo.name,
                onInputValue: _ctx.inputName,
                onBlur: _ctx.checkName,
                errMessage: _ctx.validName ? null : `正しいお名前を入力してください。`,
                required: ""
              }, null, 8, ["name", "value", "onInputValue", "onBlur", "errMessage"]),
              _hoisted_9
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(`${_ctx.companyField ? `` : `mt20`}`)
            }, [
              _createVNode(_component_MdTextfieldTag, {
                fieldStyle: "min-width:280px;max-width:100%;",
                style: {"height":"56px","min-width":"280px","max-width":"100%"},
                class: "fl fs16 text-left",
                type: `email`,
                name: `メールアドレス(必須)`,
                value: _ctx.userInfo.email,
                onInputValue: _ctx.inputEmail,
                onBlur: _ctx.checkEmail,
                errMessage: _ctx.validEmail ? null : `正しいメールアドレスを入力してください。`,
                required: ""
              }, null, 8, ["name", "value", "onInputValue", "onBlur", "errMessage"]),
              _hoisted_10
            ], 2),
            (_ctx.Util.isPresent(_ctx.companyField))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_MdTextfieldTag, {
                    fieldStyle: "min-width:280px;max-width:100%;",
                    style: {"height":"56px","min-width":"280px","max-width":"100%"},
                    class: "fl fs16 text-left",
                    type: `text`,
                    name: `${_ctx.companyField.field_name}${_ctx.companyField.is_required ? `(必須)` : ``}`,
                    value: _ctx.userInfo.company_name,
                    onInputValue: _ctx.inputCompanyName,
                    onBlur: _ctx.checkCompanyName,
                    errMessage: _ctx.validCompanyName ? null : `正しい${_ctx.companyField.field_name}を入力してください。`,
                    required: ""
                  }, null, 8, ["name", "value", "onInputValue", "onBlur", "errMessage"]),
                  _hoisted_12,
                  _hoisted_13
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.Util.isBlank(_ctx.rm.userInfo) || (!_ctx.rm.userInfo.email && !_ctx.rm.userInfo.name))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_PPTosContent, { room: _ctx.room }, null, 8, ["room"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          (true && !_ctx.isPreview)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                id: "roomCloseButton",
                class: "w100 skyblueBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
              }, _hoisted_18))
            : (_openBlock(), _createElementBlock("section", _hoisted_19, [
                (_ctx.isPreview)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "プレビューのため確定できません"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, "未入力です"))
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen", "onBeforeClose"]))
}